import { Avatar, Button, Typography } from '@mui/material';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';
import { PurpleArrowLeft } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ICategoriesList {
  burgerMenuItems: IBurgerMenuItem[];
  itemNavigationHandler: Function;
}
export const CategoriesList = ({
  burgerMenuItems,
  itemNavigationHandler,
}: ICategoriesList) => {
  return (
    <>
      {burgerMenuItems &&
        burgerMenuItems.map((menuItem: IBurgerMenuItem, index: number) => {
          return (
            <Button
              key={index}
              sx={{
                p: 0,
                width: '100%',
                justifyContent: 'flex-start',
                gap: '10px',
              }}
              onClick={() => itemNavigationHandler(menuItem)}
              onKeyDown={onEnterOrEscapeKeyDown}
              role='link'
            >
              <Avatar
                sx={{ width: '24px', height: '24px' }}
                src={menuItem.mobileIconUrl}
                alt=''
              />
              <Typography variant='body3' color='initial' component='h3'>
                {menuItem.description}
              </Typography>
              {menuItem &&
                menuItem.subItems &&
                menuItem.subItems.length > 0 && (
                  <Avatar
                    sx={{
                      width: '24px',
                      height: '24px',
                      ml: 0,
                      mr: 'auto',
                    }}
                    src={PurpleArrowLeft}
                    alt=''
                  />
                )}
            </Button>
          );
        })}
    </>
  );
};
